/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

//Career Page 
$(document).ready(function() {

  var CareerPage = {
    initRJSlider: function() {
      var SliderElement = $('.js-rj-slider');
      
      if(SliderElement.length) {
        SliderElement.not(".slick-initialized").slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true,
          fade: false,
          adaptiveHeight: true,
          speed: 300,
          cssEase: "ease",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    },
    initSLSlider: function() {
      var SliderElementSL = $('.js-spotlight-slider');
      
      if(SliderElementSL.length) {
        SliderElementSL.not(".slick-initialized").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          adaptiveHeight: false,
          speed: 300,
          cssEase: "ease",
          lazyLoad: "progressive",
          responsive: [
            {
              breakpoint: 767,
              settings: {
              	adaptiveHeight: true
              }
            }
          ]
        });
      }
    }
  }
  
  var JobPage = {
    initTabs: function() {
      var TabItem = $('.job-card-item');
      
      TabItem.on('click', function() {
      	var Self = $(this),
            TabName = Self.attr('data-item');
        
        $('.mm-job, .job-card-item')
        	.removeClass('is--active');
        $('.mm-job-short').hide(); 
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        $('.mm-job[data-content="' + TabName + '"]')
        	.addClass('is--active');
        Self.addClass('is--active');
        
        window.history.pushState(null, null, '?q=' + TabName);
      })
    },
    initExpand: function() {
      var ExpandItem = $('.mm-job-short');
      
      ExpandItem.on('click', function(e) {
        
      	var Self = $(this),
            TabName = Self.attr('data-item');
        if(!$(e.target).closest('.mm-job-share').length) {
          $('.mm-job-short').hide(); 
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          $('.mm-job[data-content="' + TabName + '"]')
          .addClass('is--active');
          $('.job-card-item[data-item="' + TabName + '"]')
          .addClass('is--active');

          window.history.pushState(null, null, '?q=' + TabName);
        }        
      })
    },
    removeTabs: function() {
    var RemoveTab = $('.back_icon p');
      
      RemoveTab.on('click', function() {
      	$(this).parents().find('.mm-job').removeClass('is--active');
        $('.job-card-item').removeClass('is--active');
      })
    },
    handlePageLoad: function() {
      var url = window.location.href;
      
      if(url.indexOf('?q=') != -1) {
      	var TabName = url.split('?q=')[1];
        
        $('.mm-job-short').hide(); 
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        $('.mm-job[data-content="' + TabName + '"]')
        	.addClass('is--active');
        $('.job-card-item[data-item="' + TabName + '"]')
        	.addClass('is--active');
        
        window.history.pushState(null, null, '?q=' + TabName);
      }
    },
    initCopyUrl: function() {
      var ShareLink = $('.js-mm-share');
      
      if(ShareLink.length) {
        var clipboard = new ClipboardJS('.js-mm-share');

        clipboard.on('success', function(e) {
          e.clearSelection();
          
          $('.tooltip-text').addClass('is--visible');
          setTimeout(function() {
          	$('.tooltip-text').removeClass('is--visible');
          }, 1500);
        });

        clipboard.on('error', function(e) {
          console.log('Error while copying link!!');
        });
      }     
    }
  }
  
  var ContactPage = {
    openPopup: function() {
      var PopupLink = $('.js-open-popup');
      
      if(PopupLink.length) {
        PopupLink.magnificPopup({
          type: 'inline',
          midClick: true,
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = this.st.el.attr('data-effect');
            },
            open: function() {
              $('html, body').css('overflow', 'hidden');
            },
            close: function() {
              $('html, body').css('overflow', 'auto');
            }
          }
        });
      }
    },
    closePopup: function() {
      var CloseButton = $('.form-status-close');
      
      CloseButton.on('click', function() {
      	$('.form-status').hide();
      })
    },
    feedBackToggle: function() {
      var feedbackSelector = $('#ContactFormFeedbackFor');
      
      feedbackSelector.on('change', function() {
      	var getName = $(this).find(':selected').attr('data-action');
        var feedbackPerson = $('.js-feedbackperson');
        
        if(getName != undefined) {
          if(getName == 'Developer') {
          	feedbackPerson.find('label').html('Developer Name');
            feedbackPerson.find('input').prop('required',true);
            feedbackPerson.addClass('is-active');
          }
          else if(getName == 'Quality Assurance') {
            feedbackPerson.find('label').html('Quality Assurance Name');
            feedbackPerson.find('input').prop('required',true);
            feedbackPerson.addClass('is-active');
          }
          else if(getName == 'Account Manager') {
          	feedbackPerson.find('label').html('Account Manager Name');
            feedbackPerson.find('input').prop('required',true);
            feedbackPerson.addClass('is-active');
          }
          else {
          	feedbackPerson.find('label').html('');
            feedbackPerson.find('input').prop('required',false);
            feedbackPerson.removeClass('is-active');
          }
        }
        else {
          feedbackPerson.find('label').html('');
          feedbackPerson.find('input').prop('required',false);
          feedbackPerson.removeClass('is-active');
        }
      })
    }
  }
  
  var OurWork = {
    initAnimation: function() {
      new WOW().init();
    }
  }
  
  var landingPage = {
    initCountdown: function() {
      (function () {
        const second = 1000,
              minute = second * 60,
              hour = minute * 60,
              day = hour * 24;

        let offerDate = "Mar 8, 2021 19:00:00",
            countDown = new Date(offerDate).getTime(),
            x = setInterval(function() {    

              let now = new Date().getTime(),
                  distance = countDown - now;
              
              var daysN = Math.floor(distance / (day));
              var hoursN = Math.floor((distance % (day)) / (hour));
              var minutesN = Math.floor((distance % (hour)) / (minute));
              var secondsN = Math.floor((distance % (minute)) / second);
              if(daysN<10){
                daysN = '0'+daysN
              }else{
                daysN = daysN
              }
              if(hoursN<10){
                hoursN = '0'+hoursN
              }else{
                hoursN = hoursN
              }
              if(minutesN<10){
                minutesN = '0'+minutesN
              }else{
                minutesN = minutesN
              }
              if(secondsN<10){
                secondsN = '0'+secondsN
              }else{
                secondsN = secondsN
              }
              
              document.getElementById("days").innerText = daysN,
                document.getElementById("hours").innerText = hoursN,
                document.getElementById("minutes").innerText = minutesN,
                document.getElementById("seconds").innerText = secondsN;

            }, 0)
        }());
    },
    registerForm: function() {
      
      function getFormData($form){
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};

        $.map(unindexed_array, function(n, i){
          indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
      }
      
//       $(".page--landing-page .btn").on('click',function(e){
//         e.preventDefault();
//         $("#register-popup").css({"visibility":"visible","opacity":"1"});
//         $("html,body").addClass("nooverflow");
//       });

      $("#register-popup").click(function(e){
        if($(e.target).closest(".popup-wrapper").length<1){
          $(this).css({"visibility":"hidden","opacity":"0"});
          $("html,body").removeClass("nooverflow");
          $('.before-form-submit').show();
          $('.after-form-submit').hide();
        }
      });

      $("#register-popup .close-popup").click(function(e){
        $(this).closest('.overlay').css({"visibility":"hidden","opacity":"0"});
        $("html,body").removeClass("nooverflow");
        $('.before-form-submit').show();
        $('.after-form-submit').hide();
      });
      
      let $form = $('#register-popup form'),
          url = 'https://script.google.com/macros/s/AKfycbxOf4GEyOK_f02H3qU66yNyaR2LNQBShwroVx68tA_Nva_hTXhi3-fBjA/exec'
      
      $('.before-form-submit [type="submit"]').on('click',function(e){
        e.preventDefault();
        var jqxhr = $.ajax({
          url: url,
          method: "GET",
          dataType: "json",
          data: getFormData($form)
        }).done(function(){
          $('.before-form-submit').hide();
          $('.after-form-submit').show();
        });
      });
    }
  }

  JobPage.initTabs();
  JobPage.initExpand();
  JobPage.removeTabs();
  JobPage.handlePageLoad();
  JobPage.initCopyUrl();
  OurWork.initAnimation();
  ContactPage.openPopup();
  ContactPage.closePopup();
  ContactPage.feedBackToggle();
  CareerPage.initRJSlider();
  CareerPage.initSLSlider(); 
  //landingPage.initCountdown();
  //landingPage.registerForm();
})

// Countdown script
